import * as React from 'react';
import { SVGProps } from 'react';

const IconInfoCircleSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm1.828-15.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM9.479 11h1.644l-1.018 5.093a2.448 2.448 0 0 0 3.932 2.364l.042-.033c.473-.377.795-.913.907-1.508l.255-1.363h-2.034l-.187.994a.525.525 0 0 1-.189.314l-.041.033a.447.447 0 0 1-.719-.432l1.24-6.277A1 1 0 0 0 12.328 9H9.979l-.5 2Z"
    />
  </svg>
);
export default IconInfoCircleSizeM;
